// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___1HJ5L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/toolbar-overlay/style.scss
// module id = 750
// module chunks = 51